import React from "react";
import styled from "styled-components";
import Paragraph from "../atoms/Paragraph";
import ChevronRight from "../atoms/icons/ChevronRight";
const SearchResultWrapper = styled.a `
    cursor: pointer;
    position: relative;
    padding: 20px 35px;
    background-color: #f6f6f6;
    border-bottom: 1px dashed #e2e2e2;
    display: block;

    &:last-child {
        border-bottom: none;
    }

    &[aria-disabled="true"] {
        cursor: default;
    }

    @media only screen and (min-width: 992px) {
        align-items: center;
    }

    &:hover {
        svg {
            transform: translateY(-50%) translateX(10px);
        }
    }
`;
const ResultHeader = styled.div `
    display: flex;
    align-items: center;
`;
const LocationIndicator = styled.div `
    display: inline-block;
    padding: 6px 8px;
    margin-left: 10px;
    border: 1px solid #dfe0e8;
    border-radius: 3px;
    color: #4a4a4a;
`;
const StyledChevronRight = styled(ChevronRight) `
    transition: transform 0.2s;
    position: absolute;
    top: 50%;
    right: 35px;
    transform: translateY(-50%);
    width: 12px;
    height: 20px;
    fill: #ff8300;
`;
const SearchResult = ({ title, isMain, chamberOfCommerceNumber, address, onClick, disabled, }) => (React.createElement(SearchResultWrapper, { onClick: onClick, "aria-disabled": disabled },
    React.createElement(ResultHeader, null,
        React.createElement("h4", null, title),
        isMain ? (React.createElement(LocationIndicator, null, "Hoofdvestiging")) : null),
    React.createElement(Paragraph, null,
        "KVK nr. ",
        chamberOfCommerceNumber),
    React.createElement("br", null),
    React.createElement(Paragraph, null, address),
    React.createElement(StyledChevronRight, null)));
export default SearchResult;
